import React from 'react'
import './ContainerComponentStyle.scss'

const Container = (props) => {
  return <div style={props.style} className="container">{props.children}</div>
}

export default Container
